export default "__VITE_ASSET__DvlEoStD__"